import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { getFont } from '@finect/tabular-utils/getFont';
export var ExpandContainer = styled.button.withConfig({
  displayName: "partials__ExpandContainer",
  componentId: "sc-cus6c5-0"
})(["display:block;cursor:pointer;font-weight:700;user-select:none;", " color:", ";", ";&:hover{color:", ";}svg{margin-right:4px;vertical-align:text-bottom;}& + button{margin-left:16px;}"], getFont(-1, 'compact'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, fontSmoothing, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryM;
});